export default __webpack_public_path__ + "static/media/pnf.284ee408.png";